import React, { useEffect, useState } from 'react';
import { Box, Text } from 'rebass/styled-components';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import _ from 'lodash';

import useTranslation from 'hooks/use-translation';
import { StyledLink } from 'shared/components';
import { useApplyCouponCode } from 'src/state/actions/cart';
import { FormattedInputWithButton } from 'shared/components/text-input-with-label';
import useStores from 'shared/hooks/use-stores';
import { StringParam, useQueryParams, withDefault } from 'use-query-params';

function PromoCodeField() {
  const { t } = useTranslation();
  const { Cart } = useStores();
  const { order, coupon, removeCoupon, rewardsProgramDisplayName, isCalculating } = Cart;
  const { dispensary } = order;

  const enableOmniauthLogin = dispensary?.storeSettings?.enableOmniauthLoginCheckout ?? false;

  const [tempPromoCode, setTempPromoCode] = useState('');
  const [showPromoCodeField, setShowPromoCodeField] = useState(false);
  const applyCouponCode = useApplyCouponCode();
  const [query] = useQueryParams({
    promo: withDefault(StringParam, null),
  });

  useEffect(() => {
    if (query.promo && enableOmniauthLogin) {
      setTempPromoCode(query.promo);
      applyCouponCode(query.promo, dispensary.id, true, rewardsProgramDisplayName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleShowPromoField = () => setShowPromoCodeField(!showPromoCodeField);

  const onPromoSubmit = (tmpPromoCode, dispensaryId) => {
    applyCouponCode(tmpPromoCode, dispensaryId, false, rewardsProgramDisplayName);
    toggleShowPromoField();
  };

  if (coupon) {
    const couponCode = _.truncate(coupon.code, { length: 16 });
    return (
      <CouponAppliedContainer mb='23px'>
        <CouponCode title={coupon.code}>
          {t('common.promoCode', 'Promo Code')}: {couponCode}
        </CouponCode>
        <StyledLink as='button' fontSize='13px' onClick={removeCoupon} disabled={isCalculating}>
          {t('common.undo', 'Undo')}
        </StyledLink>
      </CouponAppliedContainer>
    );
  }

  if (!showPromoCodeField) {
    return (
      <Box mb='23px'>
        <StyledLink as='button' fontSize='13px' onClick={() => toggleShowPromoField()} disabled={isCalculating}>
          {t('promoCode.addAPromoCode', 'Add a promo code')}
        </StyledLink>
      </Box>
    );
  }

  return (
    <FormattedInputWithButton
      mt='8px'
      mb='20px'
      id='promoCode'
      label={t('promoCode.enterAPromoCode', 'Enter promo code')}
      buttonText={t('common.apply', 'Apply')}
      value={tempPromoCode}
      onChange={(event) => setTempPromoCode(event.target.value)}
      onSubmit={() => onPromoSubmit(tempPromoCode, dispensary.id)}
      disabled={isCalculating}
    />
  );
}

export default observer(PromoCodeField);

const CouponCode = styled(Text)`
  font-size: 13px;
  color: var(--dcm-checkout-summary-text-color, #606369);
`;

const CouponAppliedContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid var(--dcm-checkout-summary-border-color, #d3dadf);
  padding: 20px 0 0 0;
`;
